/**
 * Company-scoped allowed-senders CRUD (LB-5764). Lives behind the billing gateway prefix like the
 * rest of the dashboard, so every call overrides the client base url with `billingDashboardBaseUrl`.
 */
export const billAutomationAllowedSendersRoutes = {
  companySenders: companyId => "/companies/".concat(companyId, "/allowed-senders"),
  companySenderSuggestions: companyId => "/companies/".concat(companyId, "/allowed-senders/suggestions"),
  companySender: (companyId, senderId) => "/companies/".concat(companyId, "/allowed-senders/").concat(senderId)
};